import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../accelerator-area.service';
import { AccCohortPageService, } from '../../acc-cohort.page.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'acc-goals-and-progress-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './goals-and-progress-view.part.html',
})
export class AccGoalsAndProgressViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AccCohortPageService);
	public readonly areaService = inject(AcceleratorAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

}